import axios, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/collections`;

export const create = async (data: {}) => {
  return handler(() => axios.post(baseURL, data));
}

export const update = async (data: {}) => {
  return handler(() => axios.put(baseURL, data));
}

export const fetchFields = async () => {
  return handler(() => axios.get(baseURL));
}

const collectionService = { create, update, fetchFields };

export default collectionService;
